'use strict';

var DOWNCASED_WORDS = [
  'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at',
  'by', 'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over',
  'with', 'for'
];

module.exports = DOWNCASED_WORDS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/string/var/DOWNCASED_WORDS.js
// module id = 1191
// module chunks = 0